import { IContactInfo } from './../../shared-panel-components/contact-card/contact-card.models';
import { IPanelListData } from './../../shared-panel-components/panel-list/panel-list.models';
import { switchMap } from 'rxjs/operators';
import { Observer, Observable, BehaviorSubject } from 'rxjs';
import {
  IBasicInfoStudent,
  IContactConfig,
  IBasicInfoPanelState,
  IPanelDataConfig,
  IPanelListConfigItem,
} from './basic-info-panel.models';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import {
  SCHOOL_LIST_LEFT,
  SCHOOL_LIST_RIGHT,
  SHELTER_LIST_LEFT,
  SHELTER_LIST_RIGHT,
  PRINCIPAL_CONTACT_CONFIG,
} from './basic-info-panel.constants';

@Component({
  selector: 'basic-info-panel',
  template: require('./basic-info-panel.component.html'),
  styles: [require('./basic-info-panel.component.scss')],
})
export class BasicInfoPanelComponent {
  @Input() currentStudent$: BehaviorSubject<IBasicInfoStudent>;
  @Input() expanded: boolean;
  @Output() panelStateEmitter = new EventEmitter<IBasicInfoPanelState>();
  @Output() contactClickEmitter = new EventEmitter<IContactInfo>();

  public title: string = 'Basic Info';
  public panelData$: Observable<{ [key: string]: string | IPanelListData }>;

  ngOnInit(): void {
    const configs = {
      SCHOOL_LIST_LEFT,
      SCHOOL_LIST_RIGHT,
      SHELTER_LIST_LEFT,
      SHELTER_LIST_RIGHT,
      PRINCIPAL_CONTACT_CONFIG,
    };

    this.panelData$ = this.currentStudent$.pipe(switchMap(this.getPanelData$.bind(this, configs)));
  }

  public emitContactClick(contactInfo: IContactInfo, emitter: EventEmitter<IContactInfo>): void {
    emitter.emit(contactInfo);
  }

  public emitPanelState(state: boolean, emitter: EventEmitter<IBasicInfoPanelState>): void {
    emitter.emit({ key: 'BASIC_INFO', state });
  }

  private getPanelData$(
    configs: IPanelDataConfig,
    student: IBasicInfoStudent,
  ): Observable<{ [key: string]: string | IPanelListData }> {
    const {
      SCHOOL_LIST_LEFT,
      SCHOOL_LIST_RIGHT,
      SHELTER_LIST_LEFT,
      SHELTER_LIST_RIGHT,
      PRINCIPAL_CONTACT_CONFIG,
    } = configs;
    return Observable.create((observer: Observer<any>) => {
      const schoolName = student.SCHOOL_NAME;
      const shelterFacilityName = student.SHELTER_FACILITY_NAME;
      const schoolListLeft = this.getList(student, SCHOOL_LIST_LEFT as Array<IPanelListConfigItem>);
      const schoolListRight = this.getList(student, SCHOOL_LIST_RIGHT as Array<IPanelListConfigItem>);
      const shelterListLeft = this.getList(student, SHELTER_LIST_LEFT as Array<IPanelListConfigItem>);
      const shelterListRight = this.getList(student, SHELTER_LIST_RIGHT as Array<IPanelListConfigItem>);
      const principalContactInfo = this.getContactInfo(student, PRINCIPAL_CONTACT_CONFIG as IContactConfig);
      observer.next({
        schoolName,
        shelterFacilityName,
        schoolListLeft,
        schoolListRight,
        shelterListLeft,
        shelterListRight,
        principalContactInfo,
      }),
        observer.complete();
    });
  }

  private getList(
    student: IBasicInfoStudent,
    config: Array<{ key: string; value: Function }>,
  ): Array<{ key: string; value: string }> {
    return config.map(item => ({ ...item, ...{ value: item.value(student) } }));
  }

  private getContactInfo(student: IBasicInfoStudent, config: IContactConfig): IContactInfo {
    return {
      title: config.title,
      name: student[config.namePath],
      email: student[config.emailPath],
      tooltip: config.tooltip,
    };
  }
}
